import React from "react";

export function Footer() {
  return (
    <footer className="footer">
      <ul className="sub_navi">
        <li>
          <a href="https://digital-standard.com/company" target="">
            運営会社
          </a>
        </li>
        |
        <li>
          <a href="https://hacaro.jp/privacy-policy.html" target="">
            プライバシーポリシー
          </a>
        </li>
        |
        <li>
          <a href="https://hacaro.jp/terms-mp.html" target="">
            利用規約
          </a>
        </li>
      </ul>
      <span className="copy_right">
        © Digital Standard
      </span>
    </footer>
  );
}
